import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import CreateTour from "./CreateTour";
import CreateCustomer from "./CreateCustomer";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import CountryStore from "~/stores/CountryStore";
import CreateTourStore from "../stores/CreateTourStore";
import CreateCustomerStore from "../stores/CreateCustomerStore";
import Geocoder from "~/utils/GoogleMaps/Geocoder";
import ConstantStore from "~/stores/ConstantStore";

@observer
class TourBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // one of "tour" or "customer"
      activeComponent: "tour",
      // one of "customer"  or "coCustomer"
      customerType: "",
    };
  }

  onCustomerCreated() {
    const { createTourStore, createCustomerStore } = this.props;
    const { customerType } = this.state;
    const { customer } = createCustomerStore;

    if (customerType === "customer") {
      createTourStore.setSelectedCustomer(customer);
    } else if (customerType === "coCustomer") {
      createTourStore.setSelectedCoCustomer(customer);
    } else {
      throw new Error(`Unexpected customer type ${customerType}`);
    }

    createCustomerStore.clear();

    this.showCreateTour();
  }

  showCreateCustomer(customerType) {
    const { onActiveComponentChange } = this.props;
    this.setState({ activeComponent: "customer", customerType });
    onActiveComponentChange("customer");
  }

  showCreateTour() {
    const { onActiveComponentChange } = this.props;
    this.setState({ activeComponent: "tour" });
    onActiveComponentChange("tour");
  }

  render() {
    const {
      countryStore,
      createTourStore,
      createCustomerStore,
      geocoder,
      showCustomerSection,
      createTourCustomText,
      onTourCreated,
      onTourUpdated,
      constantStore,
    } = this.props;
    const { activeComponent } = this.state;

    const { tour } = createTourStore;
    const actualUser = createTourStore.user && createTourStore.user.actualUser;
    const preferredCountry = actualUser && actualUser.address ? actualUser.address.country : "";

    return (
      <div>
        <div style={{ display: activeComponent === "tour" ? "block" : "none" }}>
          <CreateTour
            tour={tour}
            geocoder={geocoder}
            countries={countryStore.countries}
            createTourStore={createTourStore}
            model={createTourStore.formStore.model}
            isDirty={createTourStore.formStore.isDirty}
            blurred={createTourStore.formStore.blurred}
            setProperty={createTourStore.formStore.setProperty}
            setModel={createTourStore.formStore.setModel}
            bindInput={createTourStore.formStore.bindInput}
            getAggregatedError={createTourStore.formStore.getAggregatedError}
            onBlur={createTourStore.formStore.onBlur}
            createCustomerCallback={customerType => this.showCreateCustomer(customerType)}
            showCustomerSection={showCustomerSection}
            onTourCreated={onTourCreated}
            onTourUpdated={onTourUpdated}
            customText={createTourCustomText}
            timezoneOptions={constantStore.getFormList(ConstantStore.CONSTANTS.TIMEZONES)}
            preferredCountry={preferredCountry}
          />
        </div>
        {activeComponent === "customer" && (
          <CreateCustomer
            geocoder={geocoder}
            countries={countryStore.countries}
            createCustomerStore={createCustomerStore}
            model={createCustomerStore.formStore.model}
            isDirty={createCustomerStore.formStore.isDirty}
            setProperty={createCustomerStore.formStore.setProperty}
            setModel={createCustomerStore.formStore.setModel}
            bindInput={createCustomerStore.formStore.bindInput}
            getAggregatedError={createCustomerStore.formStore.getAggregatedError}
            customerCreatedCallback={() => this.onCustomerCreated()}
            goBackCallback={() => this.showCreateTour()}
            preferredCountry={preferredCountry}
          />
        )}
      </div>
    );
  }
}

TourBuilder.propTypes = {
  countryStore: PropTypes.instanceOf(CountryStore),
  createTourStore: PropTypes.instanceOf(CreateTourStore),
  createCustomerStore: PropTypes.instanceOf(CreateCustomerStore),
  geocoder: PropTypes.instanceOf(Geocoder),
  createTourCustomText: PropTypes.shape({
    updateButton: PropTypes.string,
  }),
  onActiveComponentChange: PropTypes.func.isRequired,
  showCustomerSection: PropTypes.bool,
  onTourCreated: PropTypes.func,
  onTourUpdated: PropTypes.func,
  constantStore: PropTypes.instanceOf(ConstantStore),
};

TourBuilder.defaultProps = {
  showCustomerSection: true,
  createTourCustomText: {},
  onTourCreated: tourId => {
    window.location.href = `/panel/tour/edit/${tourId}?tabView=tabImages`;
  },
};

export default ErrorWrapper(TourBuilder);
